import { LegalDocument, LegalLink, LegalP, LegalSection, LegalUl } from "../../components/LegalDocument"

export default function PurchaseTerms() {
    return (
        <LegalDocument title="Условия покупки и возврата">
            <LegalP>
                Настоящие Условия покупки и возврата (далее — Условия) определяют порядок приобретения электронных
                билетов и возврата денежных средств через онлайн-сервис «Мягкий кинотеатр» (сайт{" "}
                <LegalLink href="https://comfortkino.ru">comfortkino.ru</LegalLink> и мобильное приложение «Мягкий
                кинотеатр», далее — Сервис), оператором которого является ООО «Империя игр» (ИНН 7452030395, ОГРН
                1027403888126). Условия дополняют{" "}
                <LegalLink to="/terms">Пользовательское соглашение</LegalLink>.
            </LegalP>

            <LegalSection title="1. Покупка билетов">
                <LegalP>
                    1.1. Приобретение билетов осуществляется через интерфейс Сайта или Приложения: выбор кинотеатра,
                    сеанса, мест и способа оплаты.
                </LegalP>
                <LegalP>
                    1.2. Договор купли-продажи билета считается заключённым с момента успешной оплаты заказа.
                </LegalP>
                <LegalP>
                    1.3. После успешной оплаты электронный билет (в том числе с QR-кодом) становится доступен
                    Пользователю в Личном кабинете Сервиса и/или иным способом, предусмотренным Сервисом.
                </LegalP>
                <LegalP>
                    1.4. Билет можно предъявить для прохода в зал, отсканировав QR-код электронного билета, либо
                    получить/распечатать билет в кассе кинотеатра до начала сеанса — в порядке, установленном
                    конкретным кинотеатром.
                </LegalP>
                <LegalP>
                    1.5. Кассовый чек формируется и направляется Пользователю оператором фискальных данных — ООО
                    «Первый ОФД» — в соответствии с требованиями Федерального закона № 54-ФЗ.
                </LegalP>
                <LegalP>
                    1.6. Сервисный сбор за продажу билетов через Сервис не взимается.
                </LegalP>
            </LegalSection>

            <LegalSection title="2. Способы оплаты">
                <LegalP>2.1. Оплата билетов может производиться одним из доступных в Сервисе способов:</LegalP>
                <LegalUl
                    items={[
                        "банковская карта (в том числе через платёжные системы Visa, Mastercard, «Мир»);",
                        "Система быстрых платежей (СБП);",
                        "SberPay;",
                        "«Пушкинская карта» — при наличии такой возможности для выбранного сеанса и при соблюдении ограничений, указанных в интерфейсе Сервиса;",
                        "бонусы программы лояльности — полностью или частично, в соответствии с правилами бонусной программы.",
                    ]}
                />
                <LegalP>
                    2.2. При оплате бонусами минимальная стоимость одного билета составляет 1 (один) рубль.
                </LegalP>
                <LegalP>
                    2.3. Оператор не обрабатывает и не хранит реквизиты банковских карт. Оплата банковской картой
                    выполняется через сертифицированный платёжный шлюз банка / платёжного провайдера. Соединение и
                    передача данных осуществляются в защищённом режиме.
                </LegalP>
                <LegalP>
                    2.4. Набор доступных способов оплаты может зависеть от кинотеатра, сеанса и технических
                    возможностей платёжных систем.
                </LegalP>
            </LegalSection>

            <LegalSection title="3. Отмена билета и возврат">
                <LegalP>
                    3.1. Пользователь вправе отказаться от приобретённого билета по собственной инициативе{" "}
                    <strong className="text-white/80">до начала сеанса</strong>. Если сеанс начинается в 12:00:00,
                    отменить билет можно до 11:59:59 включительно.
                </LegalP>
                <LegalP>
                    3.2. Отмена осуществляется через Приложение или Личный кабинет на Сайте (раздел билетов / истории
                    заказов) в порядке, предусмотренном интерфейсом Сервиса.
                </LegalP>
                <LegalP>
                    3.3. При своевременной отмене (п. 3.1) Пользователю возвращается оплаченная стоимость билета.
                    Сервисный сбор не удерживается (он не взимается — см. п. 1.6).
                </LegalP>
                <LegalP>3.4. Сроки зачисления возврата зависят от способа оплаты:</LegalP>
                <LegalUl
                    items={[
                        "банковская карта — до 10 (десяти) банковских дней;",
                        "СБП — до 24 (двадцати четырёх) часов.",
                    ]}
                />
                <LegalP>
                    3.5. Фактический срок зачисления может зависеть от банка Пользователя и платёжной системы.
                </LegalP>
                <LegalP>
                    3.6. После начала сеанса возврат билетов не производится. Исключение составляют форс-мажорные
                    обстоятельства (срыв кинопоказа, некачественный кинопоказ).
                </LegalP>
                <LegalP>
                    3.7. Возврат при оплате «Пушкинской картой» и бонусами осуществляется в порядке, установленном
                    правилами соответствующей программы оплаты / лояльности и техническими возможностями Сервиса.
                </LegalP>
            </LegalSection>

            <LegalSection title="4. Ограничение ответственности">
                <LegalP>4.1. Оператор не несёт ответственности за:</LegalP>
                <LegalUl
                    items={[
                        "сбои и задержки внешних платёжных систем, банков и операторов связи;",
                        "невозможность прохода в зал по причинам, связанным с действиями Пользователя (утрата доступа к билету, предъявление недействительного билета и т.п.);",
                        "изменение расписания или отмену сеанса по инициативе кинотеатра — в таких случаях возврат оформляется в соответствии с п. 3.6 и правилами кинотеатра.",
                    ]}
                />
            </LegalSection>

            <LegalSection title="5. Контакты">
                <LegalP>
                    По вопросам покупки и возврата билетов Пользователь может обратиться через Telegram{" "}
                    <LegalLink href="https://t.me/comfortkinohelp_bot">t.me/comfortkinohelp_bot</LegalLink> или
                    использовать контакты кинотеатра в разделе{" "}
                    <LegalLink to="/contacts">Контакты</LegalLink>.
                </LegalP>
                <LegalP>
                    <strong className="text-white/80">Оператор:</strong>
                    <br />
                    ООО «Империя игр»
                    <br />
                    ИНН/КПП 7452030395/745301001
                    <br />
                    ОГРН 1027403888126
                    <br />
                    Адрес: 454091, Челябинская область, г. Челябинск, Свердловский пр-кт, д. 51а
                    <br />
                    Сайт: <LegalLink href="https://comfortkino.ru">comfortkino.ru</LegalLink>
                </LegalP>
            </LegalSection>
        </LegalDocument>
    )
}
